import {NgModule} from '@angular/core';
import {CommonModule,} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';
import {AdminRoleGuard} from './services/authentication/admin.role.guard';
import {UserRoleGuard} from './services/authentication/user.role.guard';
import {LogoutComponent} from './pages/logout/logout-layout.component';
import {RegisterComponent} from './pages/register/register.component';
import {RequestComponent} from './pages/payment/request/request.component';
import {VerifyComponent} from './pages/payment/verify/verify.component';
import {ForgetPasswordComponent} from './pages/forget-password/forget-password.component';
import {OrderDetailComponent} from './pages/payment/order-detail/order-detail.component';
import {EditorRoleGuard} from './services/authentication/editor.role.guard';
import {PsychologistRoleGuard} from './services/authentication/psychologist.role.guard';
import {CRMRoleGuard} from './services/authentication/crm.role.guard';
import {LandingLayoutComponent} from './layouts/landing-layout/landing-layout.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {PsychologistLayoutComponent} from './layouts/psychologist-layout/psychologist-layout.component';
import {EditorLayoutComponent} from './layouts/editor-layout/editor-layout.component';
import {CrmLayoutComponent} from './layouts/crm-layout/crm-layout.component';
import {UserLayoutComponent} from './layouts/user-layout/user-layout.component';
import {LoginComponent} from './pages/login/login.component';


const routes: Routes = [

  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
    canActivate: [AdminRoleGuard],
    data: {title: 'ادمین'}


  },
  {
    path: 'editor',
    component: EditorLayoutComponent,
    loadChildren: () => import('./layouts/editor-layout/editor-layout.module').then(m => m.EditorLayoutModule),
    canActivate: [EditorRoleGuard],
    data: {title: 'ادیتور'}


  },
  {
    path: 'psychologist',
    component: PsychologistLayoutComponent,
    loadChildren: () => import('./layouts/psychologist-layout/psychologist-layout.module').then(m => m.PsychologistLayoutModule),
    canActivate: [PsychologistRoleGuard],
    data: {title: 'روانشناس'}

  },
  {
    path: 'crm',
    component: CrmLayoutComponent,
    loadChildren: () => import('./layouts/crm-layout/crm-layout.module').then(m => m.CrmLayoutModule),
    canActivate: [CRMRoleGuard],
    data: {title: 'CRM'}

  },
  {
    path: 'user',
    component: UserLayoutComponent,
    loadChildren: () => import('./layouts/user-layout/user-layout.module').then(m => m.UserLayoutModule),
    canActivate: [UserRoleGuard],
    data: {title: 'پروفایل کاربری'}

  },

  {
    path: 'logout',
    component: LogoutComponent,
    data: {title: 'خروج از حساب کاربری'}

  },
  {
    path: 'forget',
    component: ForgetPasswordComponent,
    data: {title: 'فراموشی رمز عبور'}
  },
  {
    path: 'payment/request',
    component: RequestComponent,
    data: {title: 'خرید محصول'}
  },
  {
    path: 'payment/verify',
    component: VerifyComponent,
    data: {title: 'در حال تایید پرداخت شما...'}
  },
  {
    path: 'payment/order-detail',
    component: OrderDetailComponent,
  },
  {path: 'login', component: LoginComponent, data: {title: 'ورود'}},
  {path: 'register', component: RegisterComponent, data: {title: 'ثبت نام'}},
  {
    path: '',
    component: LandingLayoutComponent,
    loadChildren: () => import('./layouts/landing-layout/landing-layout.module').then(m => m.LandingLayoutModule),
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabled'
    })
  ],
  exports: [],
})
export class AppRoutingModule {
}
